'use strict';

module.exports.applicationMenu = require('./application-menu');
module.exports.applicationBar = require('./application-bar');
module.exports.applicationArea = require('./application-area');
module.exports.applicationModals = require('./application-modals');



//////////////////
// WEBPACK FOOTER
// ./src/scripts/application/components/index.js
// module id = 172
// module chunks = 0